import {useCallback, useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {Typography} from '~library/atoms/Typography';
import {IndividualMessage} from './IndividualMessage';
import {selectRecipientFilter} from '~/CreateFabricGreetingCard/reducers/recipientsMessage';
import {Pagination} from '~library/molecules/Pagination';
import {RecipientSearchInput} from '~/CreateFabricGreetingCard/routes/RecipientsMessage/components/RecipientSearch/RecipientSearch';

import './IndividualMessages.sass';

const CHUNK_SIZE = 20;

const chunkArray = (arr) => {
  const newArray = [];

  for (let i = 0; i < arr.length; i += CHUNK_SIZE) {
    const chunk = arr.slice(i, i + CHUNK_SIZE);
    newArray.push(chunk);
  }

  return newArray;
};

export const IndividualMessages = ({guests, isMobile, onPreview, scrollToTop, globalMessage}) => {
  const q = useSelector(selectRecipientFilter);
  const filteredGuests = guests?.page?.filter(
    (guest) => !q || guest.name.toLowerCase().includes(q.toLowerCase())
  );
  const pages = chunkArray(filteredGuests);
  const totalPages = pages.length;
  const [page, setPage] = useState(1);

  const memoizedList = useMemo(
    () =>
      pages[page - 1]?.map((guest) => (
        <IndividualMessage
          key={guest.guest_id}
          guest={guest}
          isMobile={isMobile}
          onPreview={onPreview}
          globalMessage={globalMessage}
        />
      )),
    [pages, page, isMobile, onPreview, globalMessage]
  );

  const onPaginationLeftArrowPress = useCallback(() => {
    const nextPage = Math.max(page - 1, 1);
    return setPage(nextPage);
  }, [page]);

  const onPaginationRightArrowPress = useCallback(() => {
    const nextPage = Math.min(page + 1, totalPages);
    return setPage(nextPage);
  }, [page, totalPages]);

  useEffect(() => {
    scrollToTop();
  }, [page, scrollToTop]);

  const resetPagination = useCallback(() => setPage(1), []);

  return (
    <div id="individual-message" className="individual-messages">
      <Typography variant="header1" classNames="global-recipients-message__header">
        Individual Messages
      </Typography>
      <RecipientSearchInput onSearch={resetPagination} />
      <div className="individual-messages__cards" data-qa-id="recipients-message-table">
        {memoizedList}
        <div style={{paddingTop: 24}}>
          {totalPages > 1 && (
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPagePress={(num) => setPage(num)}
              onLeftArrowPress={onPaginationLeftArrowPress}
              onRightArrowPress={onPaginationRightArrowPress}
            />
          )}
        </div>
      </div>
    </div>
  );
};
